/**
 * Brand Service
 * Register Angular Services for all things Brand
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 * @return Resource
 */

angular.module('flsServices').factory('Brand', ['$resource', function($resource){
    return $resource('/api/v2/brand/:id');
}]);
